<div class="loading-content" data-qa="loading-spinner">
    <div class="loading-icon"></div>
    @if (loadingText()) {
        <span class="loading-text" data-qa="loading-spinner-text">{{ loadingText() | translate }}</span>
    } @else {
        <span class="visually-hidden">{{ 'LOADING_PLACEHOLDER'|translate }}</span>
    }
</div>
